import React, {Suspense} from 'react'
import NoSSR from '@components/NoSSR'

export default function ClientSuspense({children, fallback}) {
  const [loaded, setLoaded] = React.useState(false)

  React.useEffect(() => {
    setLoaded(true)
  }, [])

  if (!loaded) return fallback

  return (
    <NoSSR>
      <Suspense fallback={fallback}>{children}</Suspense>
    </NoSSR>
  )
}
